export enum WorkStatus {
  NEW = 'NEW',

  ACTIVE = 'ACTIVE',

  COMPLETED = 'COMPLETED',
}
